
import { Component, OnInit, ViewChild, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { NotificationService } from 'src/app/shared/notification.service';
import { CommonPopup } from '../common-popup/common-popup';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { Observable, Subscription } from 'rxjs';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { CollectionReference } from '@angular/fire/compat/firestore';
import { ProductService } from '../product/product.service';
import { CategoryEditPopupComponent } from './category-edit-popup/category-edit-popup.component';
import { CategoryData } from './category.model';
import { CategoryService } from 'src/app/services/category.service';
export interface PeriodicElement {
  name: string;
  id: number;
  email: string;
  rfid: number;
  status: boolean;
  type: boolean;
  dbid: string;
}

const ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-main-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})


export class CategoryComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['id', 'name', 'email', 'credit', 'status', 'type', 'detail', 'view', 'edit'];

  approvedDataSource = new MatTableDataSource(ELEMENT_DATA);
  // notApprovedDataSource = new MatTableDataSource(ELEMENT_DATA);
  siteId: string;
  user: User;
  categories$: Observable<{}>;
  dbPath: CollectionReference;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  siteId$: Observable<any>;

  columnSettings: ColumnSetting[] = [
    {
      columnId: 'name',
      name: 'Name',
      maxLengthOnMobile: 10
    }, {
      columnId: 'isSvinnActive',
      name: 'Svinn Active',
      maxLengthOnMobile: 10
    }]

  onDelete: EventEmitter<ActionButtonEvent>;
  onAdd: EventEmitter<ActionButtonEvent>;
  onImport: EventEmitter<ActionButtonEvent>;
  onEdit: EventEmitter<ActionButtonEvent>;

  onDeleteSubscription: Subscription;
  onAddSubscription: Subscription;
  onImportSubscription: Subscription;
  onEditSubscription: Subscription;
  dialogSub: Subscription;
  paramsSub: Subscription;
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: any; }[] = [];
  topbarActionButton: { icon: string; tooltip: string; eventEmitter: any; }[] = [];



  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public auth: AuthService,
    public productService: ProductService,
    private notifierService: NotificationService,
    private categoryService: CategoryService
  ) {

    this.categories$ = this.productService.getAllCategories$()


    this.onDelete = new EventEmitter<ActionButtonEvent>();
    this.onAdd = new EventEmitter<ActionButtonEvent>();
    this.onImport = new EventEmitter<ActionButtonEvent>();
    this.onEdit = new EventEmitter<ActionButtonEvent>();


    this.onDeleteSubscription = this.onDelete.subscribe(event => {
      this.deleteUser(event.eventData.dbid);
    });


    this.onAddSubscription = this.onAdd.subscribe(event => {
      this.addCategory();
    });

    this.onEditSubscription = this.onEdit.subscribe(event => {
      this.showDetail(event.eventData);
    });


    this.auth.user$.subscribe(user => {
      this.user = user;
      // console.log(this.rowActionButtons.filter(b=> b.icon == 'edit').length)
      if (this.rowActionButtons.filter(b => b.icon == 'edit').length == 0 && this.auth.canEdit(this.user)) {
        this.rowActionButtons.push({ icon: 'edit', tooltip: 'Edit', eventEmitter: this.onEdit });
      } else if (!this.auth.canEdit(this.user)) {
        let eIndex = this.rowActionButtons.findIndex(b => b.icon == 'edit')
        if (eIndex > -1) {
          this.rowActionButtons.splice(eIndex, 1);
        }
      }

      if (this.topbarActionButton.filter(b => b.icon == 'add').length == 0 && this.auth.canEdit(this.user)) {
        this.topbarActionButton.push({ icon: 'add', tooltip: 'Add Category', eventEmitter: this.onAdd });
      } else if (!this.auth.canEdit(this.user)) {
        let aIndex = this.topbarActionButton.findIndex(b => b.icon == 'add')
        if (aIndex > -1) {
          this.topbarActionButton.splice(aIndex, 1);
        }
      }


      if (this.rowActionButtons.filter(b => b.icon == 'clear').length == 0 && this.auth.canDelete(this.user))
        this.rowActionButtons.push({ icon: 'clear', tooltip: 'Remove', eventEmitter: this.onDelete });
      else if (!this.auth.canDelete(this.user)) {
        let index = this.rowActionButtons.findIndex(b => b.icon == 'clear')
        if (index > -1) {
          this.rowActionButtons.splice(index, 1);
        }
      }
    })


  }

  ngOnInit() {
    this.auth.user$.subscribe(user => this.user = user)


    this.approvedDataSource.sort = this.sort;

  }

  addCategory(): void {
    const dialogRef = this.dialog.open(CategoryEditPopupComponent, {
      width: '700px',
      data: {
        dbid: null,
        name: '',
      }
    });

    this.dialogSub = dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
      if (!result.name?.trim()) {
        this.notifierService.showNotification("error", "Category name is required.");
        return;
      }
      this.categoryService.createCategory(result)
        .then(() => {
          this.notifierService.showNotification("success", "Category added successfully!");
        })
        .catch(error => {
          console.error("Error creating category:", error);
          this.notifierService.showNotification("error", "Failed to add category.");
        });
    });
  }


  deleteUser(id: number) {
    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "DELETE",
          message: " Are you sure to continue? ",
          buttons: ['Cancel', 'Yes']
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(id)
        this.productService.deleteCategory(id)
      }
    });

  }


  onBack() {
    this.router.navigate(['../'], { relativeTo: this.route })
  }
  openCategoryPopup(categoryData: CategoryData): void {
    const dialogRef = this.dialog.open(CategoryEditPopupComponent, {
      width: '700px',
      data: {
        dbid: categoryData?.dbid,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
      this.categoryService.updateCategory(result)
        .then(() => {
          this.notifierService.showNotification('success', ' Successfully updated!');
        })
        .catch(error => {
          this.notifierService.showNotification('error', 'Some problem happend! try again');
          console.error('Error updating category:', error);
        });
    });
  }

  showDetail(eventData: CategoryData): void {
    this.openCategoryPopup(eventData);
  }


  ngOnDestroy(): void {
    if (this.paramsSub) this.paramsSub.unsubscribe();
    if (this.dialogSub) this.dialogSub.unsubscribe();
    this.onDeleteSubscription.unsubscribe();
    this.onAddSubscription.unsubscribe();
    // this.onEditSubscription.unsubscribe();
  }

}



